<template>
    <transition name="demo">
        <div class="toast_wrap" v-if="theToast">
            <div class="toast">
                {{msg}}
            </div>
        </div>
    </transition>
</template>
 
<script>
export default {
    data() {
        return {
            theToast: false,
            msg: ""
        };
    }
};
</script>
 
<style lang="scss" scoped>
.toast_wrap {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
}
.toast {
    padding: 0.625rem /* 10/16 */;
    font-size: 0.8125rem /* 13/16 */;
    color: #fff;
    background-color: rgba(0, 0, 0, 0.85);
    border-radius: .3125rem /* 5/16 */;
    z-index: 999;
}

.demo-enter-active,
.demo-leave-active {
    transition: 0.3s ease-out;
}

.demo-enter {
    opacity: 0;
    transform: scale(1.2);
}

.demo-leave-to {
    opacity: 0;
    transform: scale(0.8);
}
</style>